<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-content width="1100px">
		<kaveh-form :key="ver" :entity="entity" :task="submit" />
	</kaveh-content>
</template>
<script>
	import { StaticPage } from '@/modules/cms/data/static-page/create'
	import { StaticPageService } from '@/modules/cms/services'
	export default {
		data()
		{
			return {
				ver: 0
			}
		},
		computed: 
		{
			entity()
			{
				return StaticPage
			},
			service()
			{
				return new StaticPageService()
			},
		},
		methods:
		{
			async submit(payload)
			{
				try
				{
					const res = await this.service.create(payload);
					if (res.status == 200)
					{
						this.ver += 1
					}

				} catch (e) { console.log(e) }
			}
		}
	}
</script>